import { useParams } from "react-router";
import styled from "styled-components";

import Editor from "./Editor";
import { BIMClass, Parameter } from "../../.../../../../modules/shared-entities";
import Back from "../../components/Back";
import Background from "../../components/Background";

const Styled = styled.div`
    align-items: flex-start;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 8vh max(64px, 8vw);

    & > a {
        margin-top: 8px;
    }

    & > header {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        font-size: 1.6rem;
        gap: 16px;

        & > * {
            flex: none;
        }
    }
`;

export default function Detail() {
    const { bimClassID, parameterID } = useParams();

    return (
        <Styled>
            <Background position="bottom right" text="revit value mapping" />
            <Back to=".." />
            <header>
                <Parameter id={ parameterID } />
                <BIMClass id={ bimClassID } />
            </header>
            <Editor
                bimClassID={ bimClassID }
                parameterID={ parameterID }
            />
        </Styled>
    );
}
